// Make cart open Rebuy
document.addEventListener('click', e => {
  if (e.target.closest('cart a') && window.Rebuy) {
    e.preventDefault();
    window.Rebuy.SmartCart.show();
  }
});

// Update cart counts when window.Rebuy cart changes
document.addEventListener('rebuy:cart.change', event => {
  window.t11Cart.set(event.detail.cart.cart);
});

// Filter out stuff we want hidden.
document.addEventListener('rebuy.beforeProductsChange', event => {
  // Access products array received from API before it's handed off to the widget object...
  const products = event.detail.products;

  products
    // Slice to creeate a shallow copy we can muck with
    .slice()
    // Reverse so that array indexes don't get changed
    .reverse()
    .forEach((product, index, arr) => {
      product.variants
        // Slice to creeate a shallow copy we can muck with
        .slice()
        // Reverse so that array indexes don't get changed
        .reverse()
        .forEach((variant, variantIndex, variantArr) => {
          // Remove gimmicks, boxsets and wholesale skus.
          if (product.product_type !== 'Puzzles & Games') {
            const exclude = ['WHOLESALE'];

            // eslint-disable-next-line max-nested-callbacks
            if (exclude.some(item => variant.sku.includes(item))) {
              product.variants.splice(variantArr - 1 - variantIndex, 1);
            }
          }

          // Remove products without variants.
          if (product.variants.length === 0) {
            products.splice(arr.length - 1 - index, 1, 1);
          }
        });
    });
});

document.addEventListener('rebuy.beforeProductsChange', event => {
  const GIFT_ID = 40118658891870;
  const WIDGET_ID = '123287';
  if (event.detail.widget.id !== WIDGET_ID) {
    return;
  }

  const count = event.detail.widget.data.cart.items.reduce(
    (acc, item) =>
      acc + (item.requires_shipping && item.id !== GIFT_ID ? item.quantity : 0),
    0,
  );

  for (let i = 0; i < event.detail.products.length; i++) {
    event.detail.products[i].quantity = count;
  }
});
